import React from "react";
import Reveal from "@/components/Reveal";
import { Mic2, Music } from "lucide-react";
import { BAND, MEMBERS } from "@/data/band";

export default function Members() {
  return (
    <section id="band" data-testid="members" className="relative py-24 md:py-32 bg-gradient-to-b from-[#0a0a0b] via-[#0d0d10] to-[#0a0a0b]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-sm font-bold uppercase tracking-[0.25em] text-[var(--sb-red)]">The Band</span>
            <h2 className="font-display text-5xl md:text-7xl text-white mt-3">Meet Songbird</h2>
            <p className="text-white/60 mt-4 text-lg">
              Five established musicians, one unstoppable live show.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {MEMBERS.map((m, i) => (
            <Reveal key={m.id} delay={i * 0.08}>
              <div
                data-testid={`member-${m.id}`}
                className={`member-card group relative rounded-2xl overflow-hidden border ${
                  m.lead ? "border-[var(--sb-red)]/50 glow-red" : "border-white/10"
                } bg-[#141416]`}
              >
                <div
                  className="member-crop aspect-[3/4] w-full"
                  style={{ backgroundImage: `url(${BAND.heroImg})`, backgroundPosition: m.pos, backgroundSize: `${m.zoom || 380}% auto` }}
                  aria-hidden
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0b] via-[#0a0a0b]/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <div className="flex items-center gap-1.5 text-[var(--sb-red)] text-xs font-bold uppercase tracking-widest mb-1">
                    {m.lead ? <Mic2 size={13} /> : <Music size={13} />} {m.role}
                  </div>
                  <div className="font-display text-2xl text-white leading-none">{m.name}</div>
                  <p className="text-white/55 text-xs mt-2 leading-snug">{m.note}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
